import React from "react";
import DocumentDetail from "../common/DocumentDetail";
import { BLANK_PLACEHOLDER } from "config/constant";
import { EXPENSE_REPORT_FIELD as FIELD } from "config/documentConstant";
import foramtNumberToKorean from "utils/formatUtils/formatNumberToKorean";
import { DocumentDtoWithAny } from "models/document/DocumentDtoWithAny";
import { Text, View } from "@react-pdf/renderer";

interface ExpenseReportDetailProps {
  documentData: DocumentDtoWithAny["documentData"];
}

const ExpenseReportDetail = ({ documentData }: ExpenseReportDetailProps) => {
  const rows = documentData[FIELD.EXPENSE_DETAILS.key].map((item: any) => [
    item.description || BLANK_PLACEHOLDER,
    Number(item.amount).toLocaleString("ko-KR") || BLANK_PLACEHOLDER,
    item.paymentPlace || BLANK_PLACEHOLDER,
    item.paymentAccount || BLANK_PLACEHOLDER,
  ]);

  return (
    <>
      <DocumentDetail.Description>
        하기 금액을 지출코자 하오니 재가하여 주시기 바랍니다.
      </DocumentDetail.Description>

      <div>
        <DocumentDetail.Section>
          <DocumentDetail.Field label={FIELD.EXPENSE_NOTE.label}>
            <Text
              style={{
                fontFamily: "Pretendard",
                fontSize: "10pt",
              }}
            >
              {documentData[FIELD.EXPENSE_NOTE.key] || BLANK_PLACEHOLDER}
            </Text>
          </DocumentDetail.Field>

          <DocumentDetail.Field label="지출금액">
            <View style={{ display: "flex", flexDirection: "row" }}>
              <View style={{ flex: 1 }}>
                <Text
                  style={{
                    fontFamily: "Pretendard",
                    fontSize: "10pt",
                  }}
                >
                  일금{" "}
                  {foramtNumberToKorean(documentData[FIELD.TOTAL_AMOUNT.key])}
                </Text>
              </View>
              <View style={{ flex: 1 }}>
                <Text
                  style={{
                    fontFamily: "Pretendard",
                    fontSize: "10pt",
                  }}
                >
                  원정{" "}
                  <Text style={{ fontWeight: "semibold" }}>
                    ₩{" "}
                    {documentData[FIELD.TOTAL_AMOUNT.key]?.toLocaleString(
                      "ko-KR",
                    ) || 0}
                  </Text>
                </Text>
              </View>
            </View>
          </DocumentDetail.Field>

          <DocumentDetail.Field label={FIELD.EXECUTION_PERIOD.label}>
            <DocumentDetail.Value.Date>
              <Text
                style={{
                  fontFamily: "Pretendard",
                  fontSize: "10pt",
                }}
              >
                {documentData[FIELD.EXECUTION_PERIOD.key] || BLANK_PLACEHOLDER}
              </Text>
            </DocumentDetail.Value.Date>
          </DocumentDetail.Field>

          <DocumentDetail.Field
            label={FIELD.EXPENSE_DETAILS.label}
            padding="0"
            boldTopBorder
          >
            <DocumentDetail.Table>
              {/* 헤더 */}
              <View style={headerStyle}>
                {["적요", "금액", "지급처", "지급계좌"].map((col) => (
                  <View style={headerCellStyle} key={col}>
                    <Text
                      style={{
                        fontFamily: "Pretendard",
                        fontSize: "10pt",
                        // textAlign: cidx === 1 ? "right" : "left", // 금액만 오른쪽 정렬
                        textAlign: "center",
                      }}
                    >
                      {col}
                    </Text>
                  </View>
                ))}
              </View>
              {/* 데이터 */}
              {rows.map((row: any, ridx: number) => (
                <View
                  style={{
                    ...rowStyle,
                    borderBottom:
                      ridx === rows.length - 1 ? "none" : rowStyle.borderBottom,
                  }}
                  key={ridx}
                >
                  {row.map((cell: any, cidx: number) => (
                    <View style={cellStyle} key={cidx}>
                      <Text
                        style={{
                          fontFamily: "Pretendard",
                          fontSize: "10pt",
                          textAlign: cidx === 1 ? "right" : "center", // 금액만 오른쪽 정렬
                        }}
                      >
                        {cell}
                      </Text>
                    </View>
                  ))}
                </View>
              ))}
            </DocumentDetail.Table>
          </DocumentDetail.Field>
        </DocumentDetail.Section>
      </div>
    </>
  );
};

export default ExpenseReportDetail;

/* 스타일 */
// const TotalAmountContainerStyle = styled.div`
//   display: flex;

//   & > div {
//     flex: 1;
//   }
// `;

const cellStyle = {
  flex: 1,
  paddingVertical: 16,
  paddingLeft: 8,
  fontSize: 10,
  fontFamily: "Pretendard",
};
const headerCellStyle = {
  ...cellStyle,
  borderBottom: "1pt solid #E5E7EB",
};
const rowStyle = {
  flexDirection: "row" as const,
  borderBottom: "1pt solid #E5E7EB",
  alignItems: "center" as const,
};
const headerStyle = {
  ...rowStyle,
  fontWeight: 600 as const,
};
